export const hasViewAccess = (permissions, resource) => {
  const entry = permissions?.find((perm) => perm?.resource === resource);
  return entry?.can_view === true;
};

export const hasAddAccess = (permissions, resource) => {
  const entry = permissions?.find((perm) => perm?.resource === resource);
  return entry?.can_add === true;
};

export const hasEditAccess = (permissions, resource) => {
  const entry = permissions?.find((perm) => perm?.resource === resource);
  return entry?.can_update === true;
};

export const hasDeleteAccess = (permissions, resource) => {
  const entry = permissions?.find((perm) => perm?.resource === resource);
  return entry?.can_delete === true;
};